<div class="auth-curtain">
  <div class="auth-content-wrapper">
    <div class="signin-wrapper window-min">
      <form #f (submit)="onSignIn()" class="signin-form">
        <div style="width: 30%; margin-left: 40px; background: black">
          <img src="../../../assets/target-icons/vlg1.svg" alt="" style="width: 50%; margin: 20% 0 10px 0;">
          <div style="width: 100%;">
            <h1 class="welcome">Welcome back</h1>
            @if (!open_forgot_password) {
              <div style="width: 100%; margin-bottom: 30px;">
                <h3 class="comment">Sign in to your ViewersLogic account</h3>
                <div class="form-group signin-class">
                  <img src="../../../assets/target-icons/login_logo1.svg" alt="" class="signin-img">
                  <input tabindex="1" type="email" class="signin-input" name="email" placeholder="Enter email" autofocus
                    id="email" aria-describedby="emailHelp" [(ngModel)]="email" required email
                    (mousedown)="check_caps_lock($event)" (keyup)="clearError()">
                </div>
              </div>
            }
          </div>
          @if (!open_forgot_password) {
            <div class="form-group">
              <div class='signin-class'>
                <img src="../../../assets/target-icons/login_password1.svg" alt="" class="signin-img">
                <input tabindex="2" type="password" class="signin-input" name="password" id="password" placeholder="Password"
                  [(ngModel)]="password" required (keydown.enter)="onSignIn()"
                  (mousedown)="check_caps_lock($event)" (keyup)="clearError()">
              </div>
            </div>
          }
          @if ((authState | async).hasError && !open_forgot_password) {
            <div class="signin-error" [ngStyle]="{'color': getColor()}">
              @if (show_error()) {
                <div style="width: 0; height: 0"></div>
              }
              {{ (authState | async).error.error }}
            </div>
          }
          @if (generalService.capsLock) {
            <div class="signin-error" >
              WARNING! Caps lock is ON.
            </div>
          }
          @if (!open_forgot_password) {
            <div style="display: grid; width: 100%;">
              <button class="forgot" tabindex="-1" (click)="open_forgot_password=!open_forgot_password">
                Forgot Your Password?
              </button>
              <button tabindex="3" class="submit" type="submit" id="login_button"
              [ngStyle]="{'opacity' : in_signin ? '0.5': '1'}">Log in</button>
              <div style="display: flex; margin-top: 30px; height: 20px;">
                <span class="companies">These Companies Trust For <span style=color:#E03B53>Single Source Data</span></span>
              </div>
              <div class="logos">
                @for (img of image_list(); track img) {
                  <div class="logo-slide">
                    <img [src]="img" alt="" class="logo-slide">
                  </div>
                }
              </div>
            </div>
          }
          @if (open_forgot_password && !in_signin) {
            <app-forgot [email]='email' (done)="open_forgot_password=false"></app-forgot>
          }
        </div>
        <img class="login-pic" src="../../../assets/target-icons/login_background1.jpg" alt="">
      </form>
    </div>
  </div>
</div>

